import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./auth";
import { CartProvider } from "./cart";
import OxyLanding from "./pages/OxyLanding";
import MyWebsites from "./pages/MyWebsites";
import CreateWebsite from "./pages/CreateWebsite";
import WebsiteEditor from "./pages/WebsiteEditor";
import PublicWebsite from "./pages/PublicWebsite";
import ArticleView from "./pages/ArticleView";
import Affiliate from "./pages/Affiliate";
import AffiliateSignup from "./pages/AffiliateSignup";
import AffiliateProducts from "./pages/AffiliateProducts";
import Support from "./pages/Support";
import Admin from "./pages/Admin";
import AdminConsoleLogin from "./pages/AdminConsoleLogin";
import BuilderPage from "./pages/BuilderPage";
import Storefront from "./pages/Storefront";
import Checkout from "./pages/Checkout";
import AuthCallback from "./AuthCallback";
import { Toaster } from "@/components/ui/sonner";

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback/>;
  return (
    <Routes>
      <Route path="/" element={<OxyLanding/>}/>
      <Route path="/dashboard" element={<MyWebsites/>}/>
      <Route path="/websites/new" element={<CreateWebsite/>}/>
      <Route path="/websites/:website_id" element={<WebsiteEditor/>}/>
      <Route path="/w/:slug" element={<PublicWebsite/>}/>
      <Route path="/w/:slug/article/:article_id" element={<ArticleView/>}/>
      <Route path="/s/:slug" element={<Storefront/>}/>
      <Route path="/s/:slug/checkout" element={<Checkout/>}/>
      <Route path="/affiliate" element={<Affiliate/>}/>
      <Route path="/affiliate/signup" element={<AffiliateSignup/>}/>
      <Route path="/affiliate/login" element={<AffiliateSignup/>}/>
      <Route path="/affiliate/products" element={<AffiliateProducts/>}/>
      <Route path="/support" element={<Support/>}/>
      <Route path="/admin" element={<Admin/>}/>
      <Route path="/oxycom-vault" element={<AdminConsoleLogin/>}/>
      <Route path="/vault" element={<AdminConsoleLogin/>}/>
      {/* Builder-specific routes */}
      <Route path="/e-commerce" element={<BuilderPage/>} />
      <Route path="/news" element={<BuilderPage/>} />
      <Route path="/pos" element={<BuilderPage/>} />
      <Route path="/hr" element={<BuilderPage/>} />
      <Route path="/education" element={<BuilderPage/>} />
      <Route path="/lawyer" element={<BuilderPage/>} />
      <Route path="/public-profile" element={<BuilderPage/>} />
      <Route path="/business" element={<BuilderPage/>} />
      <Route path="/restaurant" element={<BuilderPage/>} />
      <Route path="/portfolio" element={<BuilderPage/>} />
      <Route path="/tv-iptv" element={<BuilderPage/>} />
      <Route path="/landing-page" element={<BuilderPage/>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Router/>
            <Toaster position="top-center" richColors/>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
